import { useAtom } from '@reatom/npm-react'
import React, { useState } from 'react'
import styled from 'styled-components'

import { SearchInput } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'

import { WalletsListItems } from './wallets-list-items'

import type { WalletsListItemsProps } from './wallets-list-items'

export const WalletsList: React.FC<WalletsListItemsProps> = ({
  wallets,
  ...selectionProps
}) => {
  const { t } = useTranslation()

  const [search, setSearch] = useState('')

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setSearch(event.target.value)

  const [filtered] = useAtom(
    (ctx) => {
      return wallets.filter((wallet) => {
        const name = ctx.spy(wallet.name)
        return [name, wallet.address].some((it) =>
          it.toLowerCase().includes(search.toLowerCase()),
        )
      })
    },
    [search, wallets],
  )

  return (
    <Root>
      <Search>
        <SearchInput
          size="h40"
          value={search}
          onChange={handleInputChange}
          placeholder={t('wallet.search_by_name_address')}
        />
      </Search>
      <WalletsListItems {...selectionProps} wallets={filtered} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;

  height: 100%;
  min-height: 0;
  grid-template-rows: auto 1fr;
`

const Search = styled.div`
  margin: 10px;
  margin-block-end: 8px;
`
